<template>
  <div class="search-page">
    <div class="search-header">
      <div class="search-con">
        <van-field
            ref="mallSearch"
            class="search"
            v-model.trim="query"
            placeholder="请输入商品名或店铺名"
            clearable
            right-icon="search"
            @clear="isSearch=false"
            @input="searchOnInput"
            @click-right-icon="onSearch"
            @keyup.enter.native="onSearch"
        />
      </div>
      <div class="search-btn" @click="onSearch">搜索</div>
    </div>


    <div class="search-list-con" v-show="query.length>0 && isSearch">
      <div class="tabs-con">
        <div class="tab" :class="{'tab-active': tabActive===1}" @click="tabChange(1)">
          <div class="tab-title">商品</div>
          <div class="line-con"><i class="line"></i></div>
        </div>
        <div class="tab" :class="{'tab-active': tabActive===2}" @click="tabChange(2)">
          <div class="tab-title">店铺</div>
          <div class="line-con"><i class="line"></i></div>
        </div>
      </div>
      <div class="list-con">
        <div class="goods-list" v-show="tabActive===1">
          <van-list
              class="goods-con"
              v-model="goodsItemsLoading"
              :finished="goodsItemsFinished"
              :error.sync="goodsItemsIsError"
              error-text="请求失败，点击重新加载"
              finished-text="没有更多了"
              :immediate-check="false"
              @load="getGoods"
          >
            <div class="list" v-for="(item, i) in goodsItems" :key="i" @click="goDetail(item)">
              <div class="list-item">
                <div class="img-con">
                  <img class="img" :src="item.filePath[0] + '?imageView2/0/w/336/h/206'" alt="">
                  <div class="time-con">
                    <span class="num" v-if="item.products[0].courseType===null">已更新{{ item.products[0].currentCourseCount }}期</span>
                    <span class="num" v-if="item.products[0].courseType!==null">时长:{{ formatSeconds(item.products[0].courseType, item.products[0].duration) }}</span>
                  </div>
                  <div class="is-boutique" v-if="false"></div>
                  <div class="is-vip-shop" v-if="item.isVipShop"></div>
                  <div class="is-member-bag" v-if="item.isMemberBag"></div>
                </div>
                <div class="text-con">
                  <div class="list-title"><span class="type">{{ knowledgeTypeName(item.products[0].courseType) }}</span>{{ item.products[0].productTitle }}</div>
                  <div class="coin-text">
                    <span class="num">已售{{ item.products[0].salesVolume }}</span>
                    <span class="num">收藏{{ item.products[0].collectUserCount }}</span>
                  </div>
                  <div class="sub-text">
                    <span class="price">{{ item.products[0].sellPrice===0?'免费':('￥'+item.products[0].sellPrice) }}</span>

                  </div>
                </div>
              </div>

            </div>
          </van-list>
        </div>
        <div class="shop-list" v-show="tabActive===2">
          <van-list
              v-model="shopListLoading"
              :finished="shopListFinished"
              :error.sync="isError"
              error-text="请求失败，点击重新加载"
              finished-text="没有更多了"
              :immediate-check="false"
              @load="getShopList"
          >
            <div class="list" v-for="(item,i) in shopList" :key="i">
              <div class="list-left" @click="goShopDetail(item.shopId)">
                <div class="img-con">
                  <img class="img" :src="item.shopAvatar + '?imageView2/0/w/110/h/110'" alt="">
                  <div class="is-vip" v-if="item.isVip"></div>
                </div>
              </div>
              <div class="text-con" @click="goShopDetail(item.shopId)">
                <div class="list-title">{{ item.shopName }}</div>
                <div class="list-text">{{ item.signature || '&nbsp;'}}</div>
                <div class="sub-text"><span class="num">关注:{{ item.focuseUserCnt }}</span><span class="num">商品:{{ item.goodsCnt }}</span><span class="num">已售:{{ item.goodsSalesVolume }}</span></div>
              </div>
              <div class="btn-con">
                <!--自己为店主时不能关注自己-->
                <div v-if="!item.isShopOwner" class="btn " :class="item.isFocused?'yes':'no'" @click="changeFocusShop(item.shopId, i)"></div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>

    <div class="key-word" v-show="query.length===0 && !isSearch">
      <div class="key-word-header">
        <div class="title">搜索历史</div>
        <div class="clear-btn" @click="deleteKeyWord">清除</div>
      </div>
      <div class="word-list">
        <div class="item" v-for="(item, i) in historyWord" :key="i" @click="wordSearch(item)">{{ item }}</div>
      </div>
    </div>

  </div>
</template>

<script>
import { mallGoods } from '@/api/mall/mallGoods'
import { mallShop, focusShop } from '@/api/mall/mallShop'
export default {
  components:{
  },
  data(){
    return {
      isSearch: false,
      historyWord: this.local('mallQuery') || [],

      tabActive: 1,


      query: '', // 搜索关键字
      //商品列表
      orderBy: 'TIME', // SALES_VOLUME-销量；TIME-上架时间（最新）；PRICE-价格；PV-商品页浏览量；PERSONALIZED-个性化推荐（精选）
      sortOrder: 'DESC', // ASC-升序；DESC-降序
      goodsItems: [],
      goodsPage: 1,
      goodsSize: 20,
      goodsItemsRefreshLoading: false,
      goodsItemsLoading: false,
      goodsItemsFinished: true,
      goodsItemsIsError: false,

      //店铺列表
      shopOrderBy: 'TIME',// 排序条件：TIME-开店时间；POPULARITY-热度；PERSONALIZED-个性化推荐（精选）
      shopSortOrder: 'DESC', // ASC-升序；DESC-降序
      shopList: [],
      shopPage: 1,
      shopSize: 40,
      shopListRefreshLoading: false,
      shopListLoading: false,
      shopListFinished: false,
      isError: false,

    }
  },
  created(){
    // this.getShopList() // 获取店铺列表
    window.setTimeout(()=>{
      this.$refs.mallSearch.focus()
    },300)


  },
  methods:{
    // 标签页切换
    tabChange(type){
      this.tabActive = type
      this.onSearch()
    },
    onSearch(){
      if(this.query===''){
        return false
      }
      // 缓存搜索关键字
      let obj = this.local('mallQuery') || [];
      let index = obj.indexOf(this.query);
      if(index>=0){
        obj.splice(index, 1)
      }
      obj.unshift( this.query )
      if(obj.length>30){
        console.log(obj.length=30)
      }
      this.local('mallQuery', obj)
      this.historyWord = this.local('mallQuery')
      this.isSearch = true


      // 搜索
      if(this.tabActive===1){
        this.goodsPage = 1
        this.goodsItems = []
        this.getGoods()
      }else {
        this.shopPage = 1
        this.shopList = []
        this.getShopList()
      }
    },
    // 点击历史关键字
    wordSearch(word){
      this.query = word
      this.onSearch()
    },
    // 搜索框的值变化时
    searchOnInput(val){
      if(val.length<1){
        this.goodsItems = []
        this.shopList = []
        this.isSearch = false
      }
    },
    // 清空关键字
    deleteKeyWord(){
      this.historyWord = []
      this.removeLocal('mallQuery')
    },


    // 获取 商品列表
    getGoods() {
      let req = {
        query: this.query,
        goodsType: 'KNOWLEDGE',
        orderBy: this.orderBy,
        page: this.goodsPage,
        size: this.goodsSize,
        sortOrder: this.sortOrder
      }
      mallGoods(req).then(res=>{
        // console.log(res)
        // this.goodsItems = res.data.items

        let items = res.data.items
        // 如果是第一页需手动制空列表
        if (this.goodsPage === 1){
          this.goodsItems = items;
          if(items.totalPages<=this.goodsPage){
            this.goodsItemsLoading = false;
            this.goodsItemsFinished = true;
          }
        }else {
          if(items.length){
            this.goodsItems = this.goodsItems.concat(items)
            this.goodsItemsLoading = false
            if(res.data.totalPages===this.goodsPage){ // 到达最大页
              this.goodsItemsFinished = true;
            }
            this.goodsPage++
          }else {
            this.goodsItemsLoading = false;
            this.goodsItemsFinished = true;
          }
        }
      }).catch(() => {this.goodsItemsIsError = true;})
    },

    // 获取店铺列表
    getShopList(){
      let req = {
        query: this.query,
        openStatus: 'OPEN', // 开业状态：OPEN-营业；CLOSED-停业；FORCE_CLOSED-强制停业；
        page: this.shopPage,
        size: this.shopSize,
      };
      (this.shopOrderBy!=='') && (req.orderBy = this.shopOrderBy);
      (this.shopSortOrder!=='') && (req.sortOrder = this.shopSortOrder);
      (this.shopIsVip!=='') && (req.isVip = this.shopIsVip);
      mallShop(req).then(res=>{
        // this.shopList = res.data.items
        if(res.data.totalCount){ //是否有数据
          let arr = res.data.items
          // 如果是第一页需手动制空列表
          if (this.shopPage === 1){
            this.shopList = [];
          }
          // 把请求到的数据添加到列表
          this.shopList = this.shopList.concat(arr)
          this.shopListLoading = false
          if(res.data.totalPages===this.shopPage){ // 到达最大页
            this.shopListFinished = true;
          }
          this.shopPage++

        }else {
          this.shopListLoading = false;
          this.shopListFinished = true;
        }
      }).catch(() => {
        this.isError = true;
      })
    },

    //  店铺 关注、取关
    changeFocusShop(shopId, i){
      focusShop({shopId}).then(res=>{
        // 修改本地数据，避免列表刷新后定位不准确：
        this.shopList[i].isFocused = !this.shopList[i].isFocused;
      })
    },





    // 跳转至商品详情
    goDetail(item) {
      this.$router.push({name: 'goodsDetail', query: {goodsId: item.goodsId, shopId: item.shopId, courseType: item.products[0].courseType } })
    },
    // 跳转至店铺详情页
    goShopDetail(shopId){
      this.$router.push({name: 'mallShop', query: {shopId: shopId}})
    },
  }
}
</script>

<style lang="less" scoped>
.search-header{
  display: flex;
  height: 44px;
  background-color: #f4f4f4;
  .search-con{
    flex: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 44px;
    .search{
      height: 34px;
      line-height: 34px;
      padding: 0 12px 0 21px;
      border-radius: 16px;
    }
  }
  .search-btn{
    width: 60px;
    display: inline-flex;justify-content: center;align-items: center;
    font-size: 15px;color: #666;
  }
}
.search-list-con{
  position: relative;
   .tabs-con{
     position: absolute;top: 0;width: 100%;background-color: #fff;
     display: flex;justify-content: center;align-items: center;
     height: 44px;font-size: 16px;color: #666;
     .tab{
       position: relative;z-index: 0;height: 100%;padding: 0 5px;
       flex: 1;display: inline-flex;justify-content: center;align-items: center;
       &.tab-active {
         color: #1585f3;
         .line-con{
           position: absolute;z-index: 0;bottom: 0;width: 100%;height: 4px;
           display: flex;justify-content: center;align-items: center;
           .line{
             display: block;width: 50px;height: 2px;
             background-color: #1585f3;
           }
         }
       }
     }
   }
}
.list-con{
  position: absolute;width: 100%;top: 44px;
  .goods-list{
    .goods-con{
      display: flex;justify-content: flex-start;
      flex-wrap: wrap;
      .list{
        width: 50%;height: 178px;margin: 8px 0;
        &:nth-child(2n-1){
          padding-left: 12px;padding-right: 8px;
        }
        &:nth-child(2n){
          padding-left: 8px;padding-right: 12px;
        }
        .list-item{
          width: 100%;height: 100%;
          border-top-left-radius: 5px;border-top-right-radius: 5px;
          box-shadow: 0px 0px 1.4px 1.4px rgba(0,0,0,0.25);
        }
        .img-con{
          position: relative;z-index: 0;width: 168px;height: 103px;
          .img{
            display: block;width: 168px;height: 103px;
            border-top-left-radius: 5px;border-top-right-radius: 5px;
          }
          .time-con{
            position: absolute;z-index: 0;left: 0;bottom: 0;width: 100%;
            background-color: rgba(0,0,0,.2);
            padding: 2px 0 2px 6px;font-size: 9px;color: #fff;
          }
          .is-boutique{
            position: absolute;z-index: 0;top: 0;left: 0;
            width: 25px;height: 15px;
            background: url("../../assets/mall/goods-icon-boutique.png") no-repeat 50% 50%;
            background-size: 100%;
          }
          .is-vip-shop{
            position: absolute;z-index: 0;top: -9px;right: -4px;
            width: 26px;height: 19px;
            background: url("../../assets/mall/goods-icon-vip.png") no-repeat 50% 50%;
            background-size: 100%;
          }
          .is-member-bag{
            position: absolute;z-index: 0;bottom: -14px;right: -4px;
            width: 32px;height: 39px;
            background: url("../../assets/mall/goods-icon-member-bag.png") no-repeat 50% 50%;
            background-size: 100%;
          }
        }
        .text-con{
          flex: 1;padding: 0 4px;

          .list-title{
            margin: 4px 0 4px;
            font-size: 14px;
            padding: 2px;
            color: #2b2b2b;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            .type{
              margin: 0 5px 0 0;
              font-size: 9px;
              border: .75px solid #1585f3;
              color: #1585f3;
              border-radius: 2px;
              padding: 1px 2.5px;
            }
          }
          .coin-text{
            font-size: 9px;line-height: 20px;color: #999;
            .num{
              padding-right: 10px;
              /*.icon{
                display: inline-flex;width: 8px;height: 8px;
              }
              .goods-num-icon1{

                background: url("../assets/mall/goods-num-icon1.png") no-repeat 50% 50%;
                background-size: 100%;
              }
              .goods-num-icon2{
                background: url("../assets/mall/goods-num-icon2.png") no-repeat 50% 50%;
                background-size: 100%;
              }*/
            }
          }
          .sub-text{
            line-height: 19px;
            font-size: 9px;
            color: #999;
            .price{
              font-size: 14px;
              color: #f34b4b;
            }
          }
        }
      }
    }

  }
  .shop-list{
    .list{
      display: flex;width: 375px;height: 76px;
      box-shadow: 0 1px 0 0 #edecec;
      .list-left{
        width: 76px;height: 76px;
        display: inline-flex;justify-content: center;align-items: center;
        .img-con{
          position: relative;z-index: 0;width: 55px;height: 55px;
          .img{
            display: block;width: 100%;height: 100%;border-radius: 50%;
          }
          .is-vip{
            position: absolute;z-index: 0;top: -7px;left: 2px;
            width: 20px;height: 17px;
            background: url("../../assets/mall/shop-vip.png") no-repeat 50% 50%;
            background-size: 100%;
          }
        }
      }

      .text-con{
        flex: 1;color: #2b2b2b;
        overflow: hidden;padding-top: 10px;
        .list-title{
          font-size: 14px;color: #000;
        }
        .list-text{
          font-size: 10px;padding: 2px 0;overflow: hidden;
          text-overflow: ellipsis;white-space: nowrap;color: #999;
        }
        .sub-text{
          font-size: 10px;color: #999;
          .num{
            padding-right: 26px;
            &:last-child{
              padding-right: 0;
            }
          }
        }
      }
      .btn-con{
        width: 70px;
        display: inline-flex;justify-content: center;align-items: center;
        .btn{
          height: 21px;
          &.yes{
            width: 55px;
            background: url("../../assets/mall/shop-follow-yes.png") no-repeat 50% 50%;
            background-size: 54px 21px;
          }
          &.no{
            width: 44px;
            background: url("../../assets/mall/shop-follow-no.png") no-repeat 50% 50%;
            background-size: 44px 21px;
          }
        }
      }
    }
  }
}
.key-word{
  font-size: 14px;
  .key-word-header{
    height: 44px;
    display: flex;
    .title{
      flex: 1;padding-left: 12px;color: #999;
      display: inline-flex;align-items: center;
    }
    .clear-btn{
      /*width: 50px;*/
      padding: 0 12px;color: #333;
      display: inline-flex;justify-content: center;align-items: center;
    }
  }
  .word-list{
    padding: 12px;
    .item{
      margin: 0 12px 10px 0;
      color: #666;
      text-align: center;
      font-size: 11px;
      display: inline-block;
      padding: 10px 20px;
      background-color: #f4f4f4;
      border-radius: 15px;
    }
  }
}
</style>
<style lang="less">
.search-page{
  .van-list__finished-text{width: 100%;}
}
</style>